import { birthdayDate, genericEmail } from './user-profile-email-validator';
import {
  createValidator,
} from './validation';

const userProfileAccountRecoveryFields = {
  birthdayDate: [birthdayDate],
  email: [genericEmail],
};

const userProfileAccountRecoveryValidator = createValidator(userProfileAccountRecoveryFields);

const userProfileSAccountRecoveryValidation = values => {
  return userProfileAccountRecoveryValidator(values);
};

export default userProfileSAccountRecoveryValidation;